import { motion } from "framer-motion";

/**
 * Lightweight, dependency-free Scales of Justice emblem.
 * Used on mobile and as the loading fallback for the 3D hero.
 * Colours follow the active accent theme via `text-gold` (currentColor).
 */
export const ScalesEmblem = ({ className = "" }) => (
  <motion.div
    className={`relative flex items-center justify-center text-gold ${className}`}
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1 }}
    data-testid="scales-emblem"
  >
    <div className="absolute w-64 h-64 rounded-full blur-3xl opacity-25" style={{ background: "rgb(var(--c-gold))" }} />
    <motion.svg
      viewBox="0 0 200 200" className="relative w-64 h-64 sm:w-80 sm:h-80 drop-shadow-[0_8px_30px_rgba(0,0,0,0.5)]"
      fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
      animate={{ y: [0, -10, 0] }} transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
    >
      {/* post + base */}
      <line x1="100" y1="34" x2="100" y2="158" />
      <line x1="70" y1="158" x2="130" y2="158" />
      <ellipse cx="100" cy="165" rx="34" ry="7" fill="currentColor" opacity="0.18" />
      <circle cx="100" cy="30" r="6" fill="currentColor" />
      {/* beam */}
      <line x1="40" y1="52" x2="160" y2="52" />
      {/* chains */}
      <line x1="40" y1="52" x2="26" y2="92" />
      <line x1="40" y1="52" x2="54" y2="92" />
      <line x1="160" y1="52" x2="146" y2="92" />
      <line x1="160" y1="52" x2="174" y2="92" />
      {/* pans */}
      <path d="M16 92 Q40 124 64 92" fill="currentColor" opacity="0.12" />
      <path d="M16 92 Q40 124 64 92" />
      <path d="M136 92 Q160 124 184 92" fill="currentColor" opacity="0.12" />
      <path d="M136 92 Q160 124 184 92" />
    </motion.svg>
  </motion.div>
);

export default ScalesEmblem;
